import React from "react";

export const LeaderboardContext = React.createContext<LeaderboardModel|undefined>(undefined);